export const CORE_SDK_RELEASE = '0.0.4-2209111843'